// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hjOHr","logo":"style_logo__Qp3lX","content":"style_content__dhXG+"};